import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalConfig } from "context/GlobalConfigContext";

export function NotFound() {
	const navigate = useNavigate();
	const { configLoaded } = useGlobalConfig();

	// As rotas de menu só sabem se estão liberadas depois que a config global chega.
	// Redirecionar antes disso tira o usuário de uma página válida a cada refresh.
	useEffect(() => {
		if (!configLoaded) return;
		navigate("/");
	}, [navigate, configLoaded]);

	return null;
}
